module.exports = Object.freeze({
    Theme: "ZFPCurrentThemeIsDark",
    ZFPLabServerAddress: "ZFPLabServerAddress",
    ZFPLabServerDeviceSettings: "ZFPLabServerDeviceSettings",
    DeviceIsWorkingOnSerialPort: "ZFPDeviceIsWorkingOnSerialPort",
    DeviceSerialPortName: "ZFPDeviceSerialPortName",
    DeviceBaudRate: "ZFPDeviceBaudRate",
    DeviceIPAddress: "ZFPDeviceIPAddress",
    DevicePassword: "ZFPDevicePassword",
    CurrentArticleLimit: "UICurrentArticleLimit",
    CurrentArticleFrom: "UICurrentArticleFrom",
    CurrentArticleTo: "UICurrentArticleTo",
    CurrentClientsLimit: "UICurrentClientsLimit",
    CurrentViewType: "UICurrentViewType",
    SettingsMenuInLeft: "UISettingsMenuInLeft",
    SettingsSearchInTop: "UISettingsSearchInTop",
    SettingsTouchScreenMode: "UISettingsTouchScreenMode",
    SettingsCloseReceiptAfterPayment: "UISettingsCloseReceiptAfterPayment",
    SettingsShowCloseReceiptBarcode: "UISettingsShowCloseReceiptBarcode",
    SettingsNoFullScreen: "UISettingsHideFullScreen",
    SettingsShowPaymentValues: "UISettingsShowPaymentValues",
    SettingsNoConfirmOnKeyboardSale: "UISettingsNoConfirmOnKeyboardSale",
    SettingsShowDrawer: "UISettingsShowDrawer",
    SettingsShowFreePrice: "UISettingsShowFreePrice",
    SettingsShowFreeArticle: "UISettingsShowFreeArticle",
    PrintVatInReceipt: "FuncSettingsReceiptVATIncluded",
    ReceiptFormat: "FuncSettingsReceiptFormat",
    ExternalDisplayPortName: "UIExternalDisplayPortName",
    ExternalDisplayCodePage: "UIExternalDisplayCodePage",
    ScalePortName: "UIScalePortName",
    ScaleType: "UIScaleType",
    ArticleLimits: [
        'До първия с цена 0',
        'По избор',
        '50',
        '100',
        '500',
        '1000',
        '2000',
        '5000',
        '10000',
        '65000',
    ],
    ClientsLimits: [
        'До първия без данни',
        '10',
        '20',
        '50',
        '100',
        '250',
        '500',
        '1000'
    ],
    ViewTypes: [
        'Малки бутони',
        'Средни бутони',
        'Големи бутони',
        'Таблично',
        'Таблично (свит)'
    ],
    SerialPortNames: [
        "COM1",
        "COM2",
        "COM3",
        "COM4",
        "COM5",
        "COM6",
        "COM7",
        "COM8",
        "COM9",
        "COM10",
        "COM11",
        "COM12",
        "COM13",
        "COM14",
        "COM15"
    ],
    BaudRates: ["9600", "19200", "38400", "57600", "115200"],
    Statuses: {
        Unsent_data_for_24_hours: "Неизпратени данни повече от 72 часа",
        Blocking_3_days_without_mobile_operator: "Няма връзка с МО в 3 последователни отчета",

        Opened_Non_fiscal_Receipt: "Отворен нефискален бон",
        Opened_Fiscal_Receipt: "Отворен фискален бон",
        Opened_Fiscal_Detailed_Receipt: "Отворен фискален бон (разширен)",
        Opened_Fiscal_Receipt_with_VAT: "Отворен фискален бон (с ДДС)",
        Opened_Invoice_Fiscal_Receipt: "Отворен фискален бон - фактура",
        Duplicate_printed: "Не е отпечатан дубликат",
        Customer_report_is_not_zeroed: "Ненулев клиентски отчет",
        Daily_report_is_not_zeroed: "Ненулев дневен отчет",
        Article_report_is_not_zeroed: "Ненулев артикулен отчет",
        Operator_report_is_not_zeroed: "Ненулев операторски отчет",

        Printer_not_ready_no_paper: "Липсва хартия",
        Near_end_of_paper: "Наближава край хартия",

        // FM_produced: "ФУ е произведено",
        // FM_fiscalized: "ФУ е фискализирано",
        // Deregistered: "Дерегистрирано ФУ",
        // Decimal_point: "Десертична точка",
        // Printer_automatic_cutting: "Автоматично срязване на хартията",
        // External_display_transparent_display: "Прозрачен външен дисплей",
        // Speed_is_9600: "Скорост 9600",
        // Drawer_automatic_opening: "Автоматично отваряне на чекмедже",
        // Customer_logo_included_in_the_receipt: "Лого в бона",

        No_mobile_operator: "Няма връзка с МО",
        No_GPRS_service: "Няма GPRS услуга",

        Reports_registers_Overflow: "Препълване на регистрите",

        DateTime_not_set: "Несверен часовник",
        DateTime_wrong: "Грешен часовник",
        Hardware_clock_error: "Хадруерна грешка на часовника",

        Power_down_in_opened_fiscal_receipt: "Прекъсване на захранването по време на бон",
        RAM_reset: "RAM ресет",
        Printer_not_ready_overheat: "Прегрят принтер",

        FM_near_full: "Наближаващо препълване на ФП",
        FM_full: "Пълна ФП",
        FM_error: "Грешка във ФП",
        No_FM_module: "Липсва ФП",
        FM_Read_only: "ФП само за четене",

        SD_card_near_full: "Наближаващо препълване на КЛЕН",
        Wrong_SD_card: "Грешен КЛЕН",
        SD_card_full: "Пълен КЛЕН",
        No_task_from_NRA: "Липсва задача в ДТ",
        No_GPRS_Modem: "Липсва модем",
        Wrong_SIM_card: "Грешна SIM карта",
        No_SIM_card: "Липсва SIM карта",
    },
    Modes: {
        None: 0,
        Sales: 1,
        Operations: 2,
        ProgramArticles: 4,
        ProgClients: 8,
        Settings: 16,
        Status: 32,
        SetDateTime: 64,
        MoneyInOut: 128,
        Storno: 256,
        Invoice: 512,
        CreditNote: 1024,
        DiscountOrAddition: 2048,
        MonthlyRep: 4096,
        QRScanner: 8192,
        ProgramDepartments: 16384,
        Error: 65536,
        Info: 131072,
    },
    CodePages: [
        "cp866",
        "windows-1251"
    ],
    ScaleTypes: {
        NONE: "",
        SCALE_ON_FD: "Везна на ФУ",
        ACS15: "ACS15",
        BIMCO: "BIMCO / ELICOM 43",
        DATECS: "DATECS / ELICOM 42",
    }
}
)